import React, { useEffect, useState } from 'react';
import { LifeCycles } from 'single-spa';
import Parcel from 'single-spa-react/parcel';
import { useIsDestroyed } from '@landr/maestro';
import { importBillingMfe } from 'utils/externalImports';

export const ArtistBannerParcel: React.FC = (props) => {
    const [config, setConfig] = useState<LifeCycles<
        Record<string, unknown>
    > | null>(null);
    const isDestroyed = useIsDestroyed();

    useEffect(() => {
        importBillingMfe()
            .then((module) => {
                return module.loadSampleArtistBannerParcel();
            })
            .then((basicParcel) => {
                if (isDestroyed.current) {
                    return;
                }
                setConfig(basicParcel);
            });

        return () => {
            isDestroyed.current = true;
        };
    }, [isDestroyed]);

    if (!config) {
        return null;
    }

    return <Parcel config={config} {...props} />;
};
